<script>
    import { createEventDispatcher } from 'svelte'

    let timer = null;

    const dispatch = createEventDispatcher ();

    const onFilterInput = (event) => {
        const value = event.target.value;

        if (timer) {
            clearTimeout (timer);
            timer = null;
        }
        
        timer = setTimeout (() => {
            dispatch ('filter', { value })
        }, 400)
    }
</script>

<style>
    .ListFilter input {
        width: 100%;
        border: none;
        background-color: #ecf2f6;
        outline: none;
        margin: 0;
        padding: 5px 10px;
        font-weight: 600;
        color: var(--panel-fg);
    }
    .ListFilter input:focus {
        background-color: #dbe4ea;
    }
</style>

<div class="ListFilter">
    <input type="text" placeholder="Cerca..." value="" on:input={onFilterInput} />
</div>